import React, { useEffect, useState } from 'react';
import WebRequest from '../../WebRequest';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { CheckAuthentication, NKTEN, checkUpdates } from '../../common/common';
import Loader from '../../Components/Loader/Loader';
import { useDispatch } from 'react-redux';
import { changeSettings } from '../../features/usersettings/usersettingsSlice';

function Login() {
    const dispatch = useDispatch();
    const [preLoading, setPreLoading] = useState(true);


    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoginButtonDisabled, setIsLoginButtonDisabled] = useState(true);
    const [loading, setLoading] = useState(false);


    const enabledDisableLoginBtn = () => {
        if (password.length > 0 && email.length > 0) {
            setIsLoginButtonDisabled(false);
        } else {
            setIsLoginButtonDisabled(true);
        }
    }


    useEffect(() => {
        const checkAuth = async () => {
            const isAuthenticatedUser = await CheckAuthentication();
            if (isAuthenticatedUser) {
                navigate("/");
            }
            setPreLoading(false);
        }

        checkAuth();
        enabledDisableLoginBtn();
    }, []);


    useEffect(() => {
        enabledDisableLoginBtn();
    }, [password]);

    const signIn = async (e) => {
        e.preventDefault();
        localStorage.clear();
        setLoading(true);
        const response = await WebRequest.Login({
            "email": email,
            "password": password
        })
        setLoading(false);
        if (response.success) {
            localStorage.setItem(NKTEN, response.data.token);
            dispatch(changeSettings({ historyAccess: response.data.historyAccess, username: response.data.username, userType: response.data.userType, hasRfidCard: response.data.hasRfidCard }))
            navigate('/');
        } else {
            dispatch(changeSettings({ historyAccess: false, username: null, userType: null, hasRfidCard: null }))
            toast.error(response.message);
        }
    }



    return (
        preLoading ? <Loader loading={preLoading} blankScreen={true} /> :
            <div className='dvh-full flex flex-col px-6 py-12 lg:px-8 gap-4'>
                <div className="flex flex-1 flex-col justify-center">
                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                        <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                            Login
                        </h2>
                    </div>

                    {loading ? (<Loader halfScreen={true} loading={loading} />) : (<div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm">

                        <form className="space-y-6" onSubmit={signIn}>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                    Email address
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        onPaste={(e) => setEmail(e.target.value)}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="py-3 px-4 block w-full border-2 border-gray-200 rounded-md text-sm shadow-sm"
                                    />
                                </div>
                            </div>

                            <div>
                                <div className="flex items-center justify-between">
                                    <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                        Password
                                    </label>
                                    {/* <div className="text-sm">
                                    <a href="#" className="font-semibold text-blue-600 hover:text-blue-500">
                                        Forgot password?
                                    </a>
                                </div> */}
                                </div>
                                <div className="mt-2">
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        autoComplete="current-password"
                                        required
                                        value={password}
                                        onPaste={(e) => setPassword(e.target.value)}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="py-3 px-4 block w-full border-2 border-gray-200 rounded-md text-sm shadow-sm"
                                    />
                                </div>
                                <Link to={`/forgotpassord`} className='mt-1 block text-sm text-right text-blue-600 font-semibold'>Forgot Your Password?</Link>
                            </div>

                            <div className='grid grid-cols-2 gap-1 items-center'>
                                <Link to='/pinlogin' className='text-left text-base text-blue-600 font-semibold'>Login As Guest ?</Link>
                                <button
                                    type="submit"
                                    disabled={isLoginButtonDisabled}
                                    className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:bg-blue-300"
                                >
                                    Sign in
                                </button>
                            </div>
                        </form>
                        <p className="mt-8 text-center text-sm text-gray-500">
                            Facing a problem?{' '}
                        </p>
                        <div className="mt-4 text-center text-sm text-gray-500 center gap-8">
                            <Link to={'/reportAnIssue'} className="inline-block font-semibold p-2 text-blue-600 hover:text-blue-500 border border-blue-600">
                                Report an Issue
                            </Link>
                            <button
                                type="button"
                                onClick={checkUpdates}
                                className="inline-block font-semibold p-2 text-blue-600 hover:text-blue-500 border border-blue-600"
                            >
                                Check Updates
                            </button>
                        </div>
                    </div>)}

                </div>
                <div className='text-center'>
                    <h1 className='text-2xl text-blue-600 font-semibold'>StopTheft</h1>
                    <p>By IIMSWISS Corp.</p>
                </div>
            </div>
    )
}

export default Login